// Module
var code = "<div layout=\"row\" class=\"full-height font-weight-700\" ng-class=\"$ctrl.purpose\"> <span class=\"br-caption-2 font-weight-800 text-capitalize text-ellipsis\"> {{'STOP_PURPOSE.' + $ctrl.text | translate}} </span> <span class=\"br-caption-2\" ng-if=\"$ctrl.stopsCount\">({{$ctrl.stopsCount}})</span> </div> ";
// Exports
export default code;